
export enum ConnectorPowerType {
  AC_1_phase = 'AC_1_phase', //slow
  AC_2_phase = 'AC_2_phase', //fast
  AC_3_phase = 'AC_3_phase', //superfast
  AC_2_phase_split = 'AC_2_phase_split', // fast
  DC = 'DC', //superfast
}

export enum ConnectorPowerLabel {
  Fast = 'fast',
  Slow = 'slow',
  Turbo = 'turbo',
}

export enum ConnectorType {
  IEC_62196_T1 = 'IEC_62196_T1', //J1772
  IEC_62196_T1_COMBO = 'IEC_62196_T1_COMBO', //SAE Combo CCS
  IEC_62196_T2 = 'IEC_62196_T2',
  IEC_62196_T2_COMBO = 'IEC_62196_T2_COMBO',
  IEC_62196_T3A = 'IEC_62196_T3A',
  IEC_62196_T3C = 'IEC_62196_T3C',
  CHAOJI = 'CHAOJI',
  NEMA_5_20 = 'NEMA_5_20', // Nema-515 Name-520
  NEMA_6_30 = 'NEMA_6_30',
  NEMA_6_50 = 'NEMA_6_50', // Nema-650
  NEMA_10_30 = 'NEMA_10_30',
  NEMA_10_50 = 'NEMA_10_50',
  NEMA_14_30 = 'NEMA_14_30',
  NEMA_14_50 = 'NEMA_14_50', // Nema-1450
  TESLA = 'TESLA', //Tesla HPWC  Tesla supercharger
  CHADEMO = 'CHADEMO', //CHAdeMO
  GBT = 'GBT',
}

export enum ConnectorTypeLabel {
  EC_Type_1 = 'EC_Type_1',
  IEC_Type_2_J1772 = 'IEC_Type_2_J1772',
  IEC_Type_2 = 'IEC_Type_2',
  IEC_Type_3 = 'IEC_Type_3',
  CHAOJI = 'CHAOJI',
  NEMA = 'NEMA',
  TESLA = 'TESLA',
  CHADEMO = 'CHADEMO',
  GBT = 'GBT',
}

export enum ConnectorStatus {
  Free = 'free',
  Busy = 'busy',
  Unknown = 'unknown',
  Error = 'error',
}
